
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '交易日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: ' 融资余额(元)',
        dataIndex: 'FinVal',
        key: 'FinVal',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '融资买入额(元)',
        dataIndex: 'FinBuyIn',
        key: 'FinBuyIn',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '融资偿还额(元)',
        dataIndex: 'FinRepay',
        key: 'FinRepay',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '融券余额(元)',
        dataIndex: 'SecVal',
        key: 'SecVal',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '融券卖出量(股)',
        dataIndex: 'SecSellVolume',
        key: 'SecSellVolume',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '融券偿还量(股)',
        dataIndex: 'SecRepayVolume',
        key: 'SecRepayVolume',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      }
    ]
    pageData.data = computed(() => {
      nextTick(() => {
        pageData.spinning = false
      })
      const _data = (props.pageSourceData || {}).Margin
      if ((_data || []).length < 1) return []
      _data.forEach((item: any, i: number) => {
        item.index = 'Margin' + i
        item.time = window.moment(item.TradeDay * 1000).format('YYYY-MM-DD')
      })
      return _data
    })
    return {
      ...toRefs(pageData)
    }
  }
})
